export function sleep(ms: number): Promise<void> {
  return new Promise(resolve => {
    setTimeout(resolve, ms);
  });
}

export function formatSecondsToHMS(seconds: number, options?: { showEmptyHours?: boolean }): string {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = +seconds.toFixed(0) % 60;
  let result = `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  if (hours > 0 || options?.showEmptyHours) {
    result = `${hours.toString().padStart(2, '0')}:${result}`;
  }
  return result;
}

export function formatHMSToSeconds(timeStr: string): number {
  const parts = timeStr.split(':').map(part => Number.parseInt(part, 10));
  if (parts.some(Number.isNaN)) {
    throw new Error('Invalid time format: all segments must be integers');
  }

  if (parts.length === 1) {
    return parts[0]!;
  }
  if (parts.length === 2) {
    return parts[0]! * 60 + parts[1]!;
  }
  if (parts.length === 3) {
    return parts[0]! * 3600 + parts[1]! * 60 + parts[2]!;
  }
  throw new Error('Invalid time format');
}

export function addHoursToMilliseconds(ms: number, hours: number): number {
  return ms + hours * 60 * 60 * 1000;
}
